import type { LeagueEvent } from '@interfaces/APITravel';
import type { FormikProps } from 'formik';
import moment from 'moment-timezone';
import type { HeaderFormikProps } from '../Header';
import { StayDateRangeField } from './StayDateRangeField';

export { CalendarFooter } from './StayDateRangeField';

type Props = {
  event: LeagueEvent;
  formik: FormikProps<HeaderFormikProps>;
  triggerClassName?: string;
  onApplyDateRange?: (range: { from: Date; to: Date }) => void;
};

export function BaseCheckInOutFilter(props: Props) {
  const {
    event,
    triggerClassName,
    formik: { setFieldValue, values },
    onApplyDateRange,
  } = props;

  const hotelStartDate = moment(values.hotelStartDate).tz('GMT').toDate();
  const hotelEndDate = moment(values.hotelEndDate).tz('GMT').toDate();
  const isValidDate = (d: unknown): d is Date =>
    d instanceof Date && !isNaN(d.getTime());

  return (
    <StayDateRangeField
      event={event}
      triggerClassName={triggerClassName}
      startDate={isValidDate(hotelStartDate) ? hotelStartDate : undefined}
      endDate={isValidDate(hotelEndDate) ? hotelEndDate : undefined}
      onChange={({ from, to }) => {
        setFieldValue('hotelStartDate', from);
        setFieldValue('hotelEndDate', to);
        onApplyDateRange?.({ from, to });
      }}
    />
  );
}
